import React, { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { InputField } from "../../../../Components/formElements/InputField";
import { Col, Row } from "react-bootstrap";
import DataTable from "react-data-table-component";
//Redux
import { useSelector } from "react-redux"; //useDispatch

//Serivce
import ItemService from "../../../../services/customer_appCommonService";
import { getTodayDate } from "../../../../common/Validations";
// eslint-disable-next-line
import { TextAreaField } from "../../../../Components/formElements/TextAreaField";
import FileUploadComponent from "../../../../Components/formElements/FileUploadComponent";
import toast from "react-hot-toast";
import { TableStatusField } from "../../../../Components/formElements/TableStatusField";
// import TableDropdownMenu from "../../../../Components/TableDropdownMenu/TableDropdownMenu";

const ConfirmDispatchDL = React.forwardRef((props, ref) => {
  let userData = useSelector((state) => state?.user?.data);
  const toggleCardVisibility1 = () => {
    setCardVisible1(!isCardVisible1);
  };
  const columns = [
    {
      name: (
        <>
          <i className="bi bi-list-ol labelIcon"></i>
          Item Nr
        </>
      ),
      selector: (row) => row.local_id,
      sortable: true,
      width: "130px",
    },
    {
      name: (
        <>
          <i className="bi bi-hash labelIcon"></i>
          Del Item Nr
        </>
      ),
      selector: (row) => row.delItemNr,
      sortable: true,
      width: "150px",
    },

    {
      name: (
        <>
          <i className="bi bi-check-circle labelIcon"></i>
          Status
        </>
      ),
      selector: (row) => row.asnStatusItem,
      cell: (row) => (
        <>
          <TableStatusField status={row.statusItem} />
        </>
      ),
      sortable: true,
      width: "180px",
    },
    {
      name: (
        <>
          <i className="bi bi-box-seam labelIcon"></i>
          Material/Service
        </>
      ),
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold">{row.materialCode}</p>
          <p className="m-0 p-0">{row.materialDescription}</p>
        </div>
      ),
      width: "180px",
    },
    {
      name: (
        <>
          <i className="bi bi-boxes labelIcon"></i>
          Sales Qty
        </>
      ),
      selector: (row) => row.salesQuantity,
      sortable: true,
      width: "180px",
    },
    {
      name: (
        <>
          <i className="bi bi-truck labelIcon"></i>
          Delivery Qty
        </>
      ),
      selector: (row) => row.deliveryQuantity,
      sortable: true,
      width: "150px",
    },
    {
      name: (
        <>
          <i className="bi bi-arrow-left-right labelIcon"></i>
          Balance Qty
        </>
      ),
      selector: (row) => row.deliveryBalancePurchaseQuantity,
      sortable: true,
      width: "150px",
    },
    {
      name: (
        <>
          <i className="bi bi-rulers labelIcon"></i>
          UOM
        </>
      ),
      selector: (row) => row.orderUnitOfMeasure,
      sortable: true,
      width: "150px",
    },
    {
      name: (
        <>
          <i className="bi bi-calendar-date labelIcon"></i>
          Delivery Date
        </>
      ),
      selector: (row) => row.deliveryDate,
      sortable: true,
      width: "200px",
    },
    {
      name: (
        <>
          <i className="bi bi-building labelIcon"></i>
          Plant
        </>
      ),
      selector: (row) => row.businessLocation,
      sortable: true,
      width: "200px",
    },
    {
      name: (
        <>
          <i className="bi bi-geo-alt labelIcon"></i>
          Shortage Location
        </>
      ),
      selector: (row) => row.storagePlace,
      sortable: true,
      width: "200px",
    },
  ];
  const [isCardVisible1, setCardVisible1] = useState(true);
  const [isCardVisible2, setCardVisible2] = useState(true);

  const [getProductDetailsData, setProductDetailsData] = useState([]);
  // eslint-disable-next-line
  const [getProjects, setProjects] = useState([]);
  // eslint-disable-next-line no-unused-vars
  const [getProjectDetails, setProjectDetails] = useState([]);
  // console.log(">>getProjectDetails",getProjectDetails)
  let [formInputs, setFormInputs] = useState({
    custPurchasingDocumentNr: "",
    purchasingDocumentNr: "",
    purchasingDocumentDate: "",
    purchasingDocumentValue: "",
    customerName: "",
    poType: "",
    poValidFrom: "",
    poValidTo: "",
    projectName: "",
    projectAddress: "",
    oneMatricTon: 33,
  });

  const toggleCardVisibility2 = () => {
    setCardVisible2(!isCardVisible2);
  };

  useEffect(() => {
    // getMasterData();

    setFormInputs({
      // orderStatus: "Pending",
      projectName: "",
      customerName: "",
      dispatchZone: "",
      createdDate: new Date(),
      salesOfficerCode: userData?.userId,
      salesOfficerName: userData?.firstName,
      oneMatricTon: 33,
      projectAddress: "",
      poType: "",
      poValidFrom: "",
      poValidTo: "",
    });
    // setProductDetailsData(productDetailsData);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userData]);

  useEffect(() => {
    // getMasterData();

    setFormInputs({
      // orderStatus: "Pending",
      projectName: "",
      customerName: "",
      dispatchZone: "",
      projectAddress: "",
      createdDate: new Date(),
      salesOfficerCode: userData?.userId,
      salesOfficerName: userData?.firstName,
      deliveryId: props?.poModalData?.documentNumber,
      oneMatricTon: 33,
      poType: "",
      poValidFrom: "",
      poValidTo: "",
    });
    // setProductDetailsData(productDetailsData);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props]);

  useEffect(() => {
    if (props?.poModalData?.items?.length > 0) {
      const itemData = props.poModalData.items.map((item, index) => ({
        local_id: index + 1,
        inquiryDocumentItemNr: item.inquiryDocumentItemNr,
        materialCode: item.materialCode,
        materialDescription: item.materialDescription,
        materialGroup: item.materialGroup,
        inquiryQuantity: item.inquiryQuantity || "",
        balancePurchaseQuantity: "",
        orderQuantityMT: "",
        orderQuantityLoad: "",
        orderUnitOfMeasure: item.orderUnitOfMeasure || "",
        orderPriceUnit: item.quotePrice || "",
        deliveryDate: item.deliveryDate || "",
        plant: item.plant || "",
        storageLocn: item.storageLocn || "",
        taxCode: item.taxCode || 0,
        commissionRate: item.commissionRate || 0,
        explantRate: item.explantRate || 0,
        quotePrice: item.quotePrice || 0,
      }));

      setProductDetailsData(itemData);
    }
  }, [props?.poModalData]);
  const onInputChange = ({ target: { name, value } }) => {
    setFormInputs((formInputs) => ({ ...formInputs, [name]: value }));
  };

  /* handle save */
  const handleSave = async () => {
    const obj = {
      deliveryId: props?.poModalData?.documentNumber,
      dispatchDate: new Date(),
      remarks: formInputs.description,
    };
    await ItemService.confirmDispatch(obj).then((item) => {
      // console.log('>> item!',item);
      if (item?.status === 200) {
        toast.success(item?.message || "added successfully", {
          duration: 2000,
          position: "top-right",
        });
        // props.onSuccess();
        props.onHide();
      } else {
        // setErrorMsg('*'+ item?.message);
        toast.error(item?.message || "Please try again !!", {
          duration: 4000,
          position: "top-right",
        });
      }
    });
  };

  // For Upload Success
  const onSuccessUploadDocumentType = (data) => {
    setFormInputs((formInputs) => ({
      ...formInputs,
      [data.fieldName]: data.attachmentId,
    }));
  };

  return (
    <Modal
      show={props.show}
      onHide={props.onHide}
      aria-labelledby="contained-modal-title-vcenter"
      dialogClassName="modal-90w"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          Confirm Dispatch{" "}
          {props?.poModalData?.documentNumber
            ? `- ${props?.poModalData?.documentNumber}`
            : " "}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Row className="mb-2">
          <Col xs={12} md={2} lg={2} className="headerButtonAlign">
            <button
              className="btnInfo"
              onClick={handleSave} /* disabled={disable} */
            >
              Save
            </button>
          </Col>
        </Row>
        <div className="accordion mb-4" id="accordionExample">
          <div className="accordion-item">
            <h2 className="accordion-header">
              <Row className="accordion-button">
                <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                  <i
                    className={`bi ${
                      isCardVisible1 ? "bi-chevron-down" : "bi-chevron-right"
                    }`}
                    onClick={toggleCardVisibility1}
                  ></i>
                </Col>
                <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                  <span className="iconLogo">CD</span>
                </Col>
                <Col xs={8} md={9} lg={9}>
                  <span className="headerTitle">PO Details</span>
                  <span className="subHeaderTitle">PO Details</span>
                </Col>
              </Row>
            </h2>

            <div
              className={`accordion-collapse collapse show ${
                isCardVisible1 ? "visible" : ""
              }`}
            >
              <div className="accordion-body">
                <Row className="pt-2 pb-4 d-flex align-items-center">
                  <Col xs={12} md={4} lg={4} className="commLeftRightPadding">
                    <InputField
                      className="inputBox"
                      label="Dispatch Date"
                      id="purchasingDocumentDate"
                      name="purchasingDocumentDate"
                      type="date"
                      value={
                        formInputs?.purchasingDocumentDate ||
                        getTodayDate("") ||
                        ""
                      }
                      onChange={onInputChange}
                      disabled={false}
                    />
                  </Col>
                  <Col
                    xs={12}
                    md={4}
                    lg={4}
                    className="commTopButtonRightLeftPadding"
                  >
                    <InputField
                      className="inputBox"
                      label="Ship to Party"
                      name="shipToParty"
                      placeholder=""
                      value={formInputs.customerCode || ""}
                      onChange={onInputChange}
                      disabled={false}
                    />
                  </Col>
                  <Col
                    xs={12}
                    md={4}
                    lg={4}
                    className="commTopButtonRightLeftPadding d-flex-column"
                  >
                    <InputField
                      className="inputBox"
                      label="Customer Name"
                      name="organisationName"
                      value={formInputs.organisationName || ""}
                      onChange={onInputChange}
                      disabled={false}
                    />
                  </Col>
                  <Col
                    xs={12}
                    md={4}
                    lg={4}
                    className="commTopButtonRightLeftPadding"
                  >
                    <InputField
                      className="inputBox"
                      label="Company Code"
                      name="companyCode"
                      placeholder=""
                      value={formInputs.companyCode || ""}
                      disabled={false}
                    />
                  </Col>

                  <Col xs={12} md={4} lg={4} className="commLeftRightPadding">
                    <FileUploadComponent
                      id="supportingDoc"
                      name="supportingDoc"
                      label="Supporting Document"
                      allowedTypes={[
                        "image/png",
                        "image/jpeg",
                        "application/pdf",
                      ]}
                      multiple={true} // Change to `false` for single file selection
                      required={true}
                      onSuccessUpload={onSuccessUploadDocumentType}
                      value={formInputs.supportingDoc || ""}
                      // disabled={editMode}
                    />
                  </Col>
                </Row>
              </div>
            </div>
          </div>
        </div>
        {/* table */}
        <div className="accordion mb-4" id="accordionExample">
          <div className="accordion-item">
            <h2 className="accordion-header">
              <Row className="accordion-button">
                <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                  <i
                    className={`bi ${
                      isCardVisible2 ? "bi-chevron-right" : "bi-chevron-down"
                    }`}
                    onClick={toggleCardVisibility2}
                  ></i>
                </Col>
                <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                  <span className="iconLogo">PD</span>
                </Col>
                <Col xs={12} md={9} lg={9}>
                  <span className="headerTitle">Product Details</span>
                  <span className="subHeaderTitle">Product Details</span>
                </Col>
                {/* <Col xs={12} md={2} lg={2} className="headerButtonAlign">
                  <button className="btnTable" onClick={addProductDetails}>
                    <i className="bi bi-plus-lg"></i> Add
                  </button>
                </Col> */}
              </Row>
            </h2>
            <div
              // id="acc"
              className={`accordion-collapse collapse show ${
                isCardVisible2 ? "visible" : ""
              }`}
              // aria-labelledby="headingOne"
              // data-bs-parent="#accordionExample"
            >
              <div className="accordion-body">
                <Row>
                  <Col xs={12} md={12} lg={12}>
                    <DataTable
                      title=""
                      columns={columns}
                      data={getProductDetailsData}
                      // progressPending={loading}
                      // paginationRowsPerPageOptions={Constants.ROW_PER_PAGE}
                      pagination
                      // paginationServer
                      // paginationTotalRows={totalRows}
                      // onChangeRowsPerPage={handlePerRowsChange}
                      // onChangePage={handlePageChange}
                      // selectableRows
                      // onSelectedRowsChange={handleChange}
                    />
                  </Col>
                </Row>
              </div>
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
});

export default ConfirmDispatchDL;
